import { Fragment } from "react"
import Entry from "./Entry/Entry"
import { LogoEntry } from "./Entry/LogoEntry/LogoEntry"
import { Grid2, useMediaQuery } from "@mui/material"
import { getPlatform } from "../../../../utilities/orientationAndPlatform"


export default function EntryContainer({...params}){
    let platform = getPlatform()
    
    let isNarrowDesktop = useMediaQuery('(max-width:1261px)')
    let entryContainerGridAlignment = ''
    if (platform === 'desktop' && isNarrowDesktop) entryContainerGridAlignment = 'center'
    else entryContainerGridAlignment = 'space-between'

    let pageMode = params.pageMode
    let entries = params.stationAttributes
    let stateObject = params.stateObject
    let setStateObjectEntryHelper = params.setStateObjectEntryHelper
    let setStateObjectEntryFieldHelper = params.setStateObjectEntryFieldHelper
    let logoURLState = params.logoURLState
    let setLogoURLState = params.setLogoURLState
    let updatedFieldsCountState = params.updatedFieldsCountState
    let setUpdatedFieldsCountState = params.setUpdatedFieldsCountState

    let channelID = String(stateObject.call_sign.oldValue + '-' + stateObject.affiliation.oldValue).toLowerCase()

    function getEntries(_entry, index, entries){

        //1 column view for mobile case
        if (platform === 'mobile') {
            return (
                <Fragment key={entries[index]}>
                    <Entry 
                        pageMode={pageMode}
                        stateObject={stateObject}
                        setStateObjectEntryHelper={setStateObjectEntryHelper}
                        setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                        title={entries[index]}
                    />
                </Fragment>
            )
        }


        //3 column view for desktop case
        else if (platform === 'desktop'){

            //special case for when entries.length % 3 === 1
            if (entries.length - index === 1 && entries.length % 3 === 1){
                return (
                    <Fragment key={entries[index]}>

                            <Entry 
                                pageMode={pageMode}
                                stateObject={stateObject}
                                setStateObjectEntryHelper={setStateObjectEntryHelper}
                                setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                                title={entries[index]}
                                updatedFieldsCountState={updatedFieldsCountState}
                                setUpdatedFieldsCountState={setUpdatedFieldsCountState}
                            />

                    </Fragment>
                )
            }

            //special case for when entries.length % 3 === 2
            else if (entries.length - index === 2 && entries.length % 3 === 2 ){
                return (
                    <Fragment key={entries[index]}>
                        <Entry 
                            pageMode={pageMode}
                            stateObject={stateObject}
                            setStateObjectEntryHelper={setStateObjectEntryHelper}
                            setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                            title={entries[index]}
                            updatedFieldsCountState={updatedFieldsCountState}
                            setUpdatedFieldsCountState={setUpdatedFieldsCountState}
                        />
                        <Entry 
                            pageMode={pageMode}
                            stateObject={stateObject}
                            setStateObjectEntryHelper={setStateObjectEntryHelper}
                            setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                            title={entries[index+1]}
                            updatedFieldsCountState={updatedFieldsCountState}
                            setUpdatedFieldsCountState={setUpdatedFieldsCountState}
                        />
                    </Fragment>
                )
            }

            else if (index % 3 === 0) {
                return (
                    <Fragment key={entries[index]}>
                        <Entry 
                            pageMode={pageMode}
                            stateObject={stateObject}
                            setStateObjectEntryHelper={setStateObjectEntryHelper}
                            setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                            title={entries[index]}
                            updatedFieldsCountState={updatedFieldsCountState}
                            setUpdatedFieldsCountState={setUpdatedFieldsCountState}
                        />
                        <Entry 
                            pageMode={pageMode}
                            stateObject={stateObject}
                            setStateObjectEntryHelper={setStateObjectEntryHelper}
                            setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                            title={entries[index+1]}
                            updatedFieldsCountState={updatedFieldsCountState}
                            setUpdatedFieldsCountState={setUpdatedFieldsCountState}
                        />
                        <Entry 
                            pageMode={pageMode}
                            stateObject={stateObject}
                            setStateObjectEntryHelper={setStateObjectEntryHelper}
                            setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                            title={entries[index+2]}
                            updatedFieldsCountState={updatedFieldsCountState}
                            setUpdatedFieldsCountState={setUpdatedFieldsCountState}
                        /> 
                    </Fragment>
                )
            }
        }
    }


    return (
        <>
            <Grid2 container justifyContent={entryContainerGridAlignment} rowGap={'5px'} columns={3} width={'100%'} id={'EntryContainerGrid'}>
                {entries.map((_entry, index) => getEntries(_entry, index, entries))} 
                <LogoEntry pageMode={pageMode} channelID={channelID} logoURLState={logoURLState} setLogoURLState={setLogoURLState}/>
            </Grid2>
        </>
    )
}
